import { render, staticRenderFns } from "./Respondidas.vue?vue&type=template&id=221661ae"
import script from "./Respondidas.vue?vue&type=script&lang=js"
export * from "./Respondidas.vue?vue&type=script&lang=js"
import style0 from "./Respondidas.vue?vue&type=style&index=0&id=221661ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports